import createRoute from '@widesk-ui/tools/createRoute';
import UserModel   from '@models/account/UserModel';

export default createRoute.dashboard('/users', 'account', 'UserDashboard', UserModel.localize());